import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";

// Load `selectedClients` and `selectedBrands` state from localStorage
const loadState = () => {
  try {
    const selectedClients = localStorage.getItem("selectedClients");
    const selectedBrands = localStorage.getItem("selectedBrands");
    
    const state = {};
    // Only check for null; an empty array is stored as "[]", which is truthy
    if (selectedClients !== null) {
      state.selectedClients = JSON.parse(selectedClients);
    }
    if (selectedBrands !== null) {
      state.selectedBrands = JSON.parse(selectedBrands);
    }
    
    return Object.keys(state).length > 0 ? state : undefined;
  } catch (err) {
    console.error("Could not load state from localStorage", err);
    return undefined;
  }
};

// Save `selectedClients` and `selectedBrands` state to localStorage
const saveState = (state) => {
  try {
    // Persist even empty arrays; only skip if the slice is truly undefined
    if (state.selectedClients !== undefined) {
      localStorage.setItem("selectedClients", JSON.stringify(state.selectedClients));
    }
    if (state.selectedBrands !== undefined) {
      localStorage.setItem("selectedBrands", JSON.stringify(state.selectedBrands));
    }
  } catch (err) {
    console.error("Could not save state to localStorage", err);
  }
};

// Load initial state
const preloadedState = loadState();

const store = configureStore({
  reducer: rootReducer,
  preloadedState, // Load `selectedClients` into Redux store
});

// Subscribe to save state whenever it changes
store.subscribe(() => {
  saveState(store.getState());
});

export default store;
